export default __webpack_public_path__ + "static/media/a037-b.09aecef9.jpg";